import { render } from "./portal_form_answers.html?vue&type=template&id=01280032&external"
import script from "./portal_form_answers.js?vue&type=script&lang=js&external"
export * from "./portal_form_answers.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__